import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { Button, FormGroup, Label, Input } from "reactstrap";
import axios from "axios";
import Title from "./../../../../components/general/AdminPageTitle/AdminPageTitle";

import Form from "./../../../general/Form/Form";

const config = {
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
};

class UserForm extends Component {
  state = {
    name: null,
    email: null,
    privilege: null,
    password: "",
    privilegeList: [],
    isOwner: false,
  };

  onFormSubmitHandler = async (e) => {
    e.preventDefault();
    let data = {
      name: this.state.name,
      email: this.state.email,
      privilege_id: this.state.privilege,
      password: this.state.password
    };
    if (this.props.edit) {
      let res = await axios.put(`${process.env.REACT_APP_API_HOST}/user/${this.props.id}`, data, config);
      if (res.status === 200 && res.data.updated_user && res.data.updated_user[0].user_id) {
        alert("Boxi team user was updated");
        this.props.history.push(`/dashboard/admin/team`);
      }
    } else {
      try {
        let res = await axios.post(`${process.env.REACT_APP_API_HOST}/user/admin`, data, config);
        if (res.status === 200 && res.data.new_admin && res.data.new_admin[0].user_id) {
          alert("Boxi team user was created");
          this.props.history.push(`/dashboard/admin/team`);
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  deleteUser = async () => {
    try {
      let res = await axios.delete(`${process.env.REACT_APP_API_HOST}/user/${this.props.id}`, {withCredentials: true});
      if (res.status === 200 && res.data.deleted_user && res.data.deleted_user[0].user_id) {
        alert("Boxi team user was deleted");
        this.props.history.push(`/dashboard/admin/team`);
      }
    } catch (err) {
      console.log(err);
    }
  };

  componentDidMount = async () => {
    let isOwner = parseInt(localStorage.getItem("role"))===3;
    if (this.props.edit) {
      // load user information
      try {
        let res = await axios.get(`${process.env.REACT_APP_API_HOST}/user/${this.props.id}`, {withCredentials: true});
        if (res.status === 200 && res.data.user && res.data.user[0].user_id) {
          let user = res.data.user[0];
          // let isOwner = parseInt(localStorage.getItem("role"))===3;
          this.setState({
            name: user.name,
            email: user.email,
            privilege: user.privilege_id,
            isOwner: isOwner
          });
        }
      } catch (err) {
        console.log(err);
      }
    }
      // try {
      //   axios
      //   .get(`${process.env.REACT_APP_API_HOST}/user/${this.props.}`)
      // }
    this.setState({
      privilegeList: [
        <option key={1} value={1} disabled={!isOwner}>
          Administrator
        </option>,
        <option key={2} value={2}>
          User
        </option>,
        <option key={3} value={3} disabled={!isOwner}>
          Owner
        </option>,
        <option key={5} value={5} disabled={!isOwner}>
          Communication
      </option>
      ]
    });
  };

  nameChangeHandler = (e) => {
    this.setState({
      name: e.target.value
    });
  };

  emailChangeHandler = (e) => {
    this.setState({
      email: e.target.value
    });
  };

  privilegeSelectHandler = (e) => {
    console.log("Selected Priv: " + e.target.value);
    this.setState({
      privilege: parseInt(e.target.value)
    });
  };

  passwordChangeHandler = (e) => {
    this.setState({
      password: e.target.value
    });
  };

  render() {
    const sectionStyle = {
      width: "600px"
    };

    const formStyle = {
      padding: "20px"
    };

    const titleStyle = {
      marginBottom: "16px"
    }
    const title = this.props.edit ? "Edit Boxi Team User" : "Create Boxi Team User";
    return (
      <>
        <Title style={titleStyle}>{title}</Title>
        <Form formStyle={formStyle} sectionStyle={sectionStyle}>
          <FormGroup>
            <Label>Name</Label>
            <Input
              type="text"
              value={this.state.name ? this.state.name : ""}
              onChange={this.nameChangeHandler}
              placeholder="Enter boxi team user's name"
              disabled={(!this.state.isOwner) && (this.props.edit == true) && (this.state.privilege !=2)}
            />
          </FormGroup>
          <FormGroup>
            <Label>Email</Label>
            <Input
              type="text"
              value={this.state.email ? this.state.email : ""}
              onChange={this.emailChangeHandler}
              disabled={(!this.state.isOwner) && (this.props.edit == true) && (this.state.privilege !=2)}
              placeholder="Enter boxi team user's email"
            />
          </FormGroup>


          <FormGroup>
            <Label>Privilege / Role</Label>
            <Input
              type="select"
              onChange={this.privilegeSelectHandler}
              disabled={(!this.state.isOwner) && (this.props.edit == true) && (this.state.privilege !=2)}
              value={this.state.privilege ? this.state.privilege : ""}
            >
              <option>-- Select Privilege / Role --</option>
              {this.state.privilegeList}
            </Input>
          </FormGroup>

          <FormGroup className="mb-4">
            <Label>Password</Label>
            <Input
              type="text"
              value={this.state.password ? this.state.password : ""}
              onChange={this.passwordChangeHandler}
              placeholder="Enter boxi team user's password"
              disabled={(!this.state.isOwner) && (this.props.edit == true) && (this.state.privilege !=2)}
            />
          </FormGroup>


          <FormGroup>
            <Button color="primary" onClick={this.onFormSubmitHandler}
            disabled={(!this.state.isOwner) && (this.props.edit == true) && (this.state.privilege !=2)}
            >
              {this.props.edit ? "Update" : "Create"}
            </Button>
            {this.props.edit ? (
              <Button color="danger" onClick={this.deleteUser} style={{ float: "right" }}
              disabled={(!this.state.isOwner) && (this.props.edit == true) && (this.state.privilege !=2)}
              >
                Delete
              </Button>
            ) : null}
          </FormGroup>
        </Form>
      </>
    );
  }
}

export default withRouter(UserForm);
